/* ============================================
   SHOPPABLE PRODUCT CARD JS
   Wires up swatch click (colour select), size
   click (add to cart), and title text swap.
   Only runs on cards with .grid-product--shoppable.
   ============================================ */

(function() {
  'use strict';

  function initCard(card) {
    if (card.dataset.shoppableInitialised === 'true') return;
    card.dataset.shoppableInitialised = 'true';

    var dataEl = card.querySelector('.grid-product__variants-data');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('Shoppable card: invalid variants JSON', e);
      return;
    }

    var titleEl = card.querySelector('.grid-product__title');
    var originalTitle = titleEl ? titleEl.getAttribute('data-product-title') : '';
    var swatches = card.querySelectorAll('.grid-product__swatch-trigger');
    var colourImages = card.querySelectorAll('.grid-product__colour-image');
    var sizeButtons = card.querySelectorAll('.grid-product__size');

    var state = {
      selectedColour: null
    };

    // ---------- Selecting a colour ----------

    function selectColour(colour) {
      state.selectedColour = colour;

      // Update swatch visual state
      swatches.forEach(function(sw) {
        sw.classList.toggle('is-selected', sw.dataset.colour === colour);
      });

      // Swap the visible image to this colour's featured image
      colourImages.forEach(function(img) {
        img.classList.toggle('is-active', img.dataset.colour === colour);
      });

      // Update size availability for this colour
      updateSizeAvailability(colour);

      // Update the title text to show the colour name (while hovered)
      if (titleEl) {
        titleEl.textContent = colour;
      }
    }

    function updateSizeAvailability(colour) {
      sizeButtons.forEach(function(btn) {
        var size = btn.dataset.size;
        var match = variants.find(function(v) {
          return v.colour === colour && v.size === size;
        });
        var isAvailable = match && match.available;
        btn.dataset.sizeAvailable = isAvailable ? 'true' : 'false';
        btn.dataset.variantId = match ? match.id : '';
      });
    }

    // ---------- Hover behaviour (reveal + title) ----------

    // When the card is hovered (not just a swatch), show the colour name for
    // whichever swatch is selected (default: first colour).
    function showColourTitle() {
      if (!titleEl) return;
      if (state.selectedColour) {
        titleEl.textContent = state.selectedColour;
      }
    }

    function restoreTitle() {
      if (titleEl && originalTitle) {
        titleEl.textContent = originalTitle;
      }
    }

    card.addEventListener('mouseenter', showColourTitle);
    card.addEventListener('mouseleave', restoreTitle);

    // ---------- Swatch click: prevent navigation, select colour ----------

    swatches.forEach(function(sw) {
      sw.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        selectColour(sw.dataset.colour);
      });
    });

    // ---------- Size click: add to cart ----------

    sizeButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.dataset.sizeAvailable !== 'true') return;
        addToCartAndOpenDrawer(variantId, btn);
      });
    });

    // ---------- Initial state: pick first available colour ----------

    if (swatches.length > 0) {
      // Default to the first colour that has any available variant, else first
      var firstAvailable = null;
      for (var i = 0; i < swatches.length; i++) {
        var c = swatches[i].dataset.colour;
        var hasAvail = variants.some(function(v) {
          return v.colour === c && v.available;
        });
        if (hasAvail) { firstAvailable = c; break; }
      }
      selectColour(firstAvailable || swatches[0].dataset.colour);
      // Reset title to product title (selectColour set it to colour name)
      restoreTitle();
    }
  }

  // ---------- Add to cart ----------

  function addToCartAndOpenDrawer(variantId, triggerEl) {
    if (triggerEl) {
      triggerEl.setAttribute('disabled', 'disabled');
      triggerEl.dataset.wasText = triggerEl.querySelector('.grid-product__size-add').textContent;
      triggerEl.querySelector('.grid-product__size-add').textContent = 'Adding…';
    }

    var body = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(err) { throw err; });
      }
      return res.json();
    })
    .then(function() {
      // Trigger the theme's own cart update — this matches Archetype themes'
      // convention. The cart drawer listens for these events.
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
        bubbles: true
      }));
      // Open the cart drawer
      openCartDrawer();
    })
    .catch(function(err) {
      console.warn('Add to cart failed', err);
      if (triggerEl && triggerEl.dataset.wasText) {
        triggerEl.querySelector('.grid-product__size-add').textContent = triggerEl.dataset.wasText;
      }
    })
    .finally(function() {
      if (triggerEl) {
        triggerEl.removeAttribute('disabled');
        if (triggerEl.dataset.wasText) {
          triggerEl.querySelector('.grid-product__size-add').textContent = triggerEl.dataset.wasText;
        }
      }
    });
  }

  function openCartDrawer() {
    // Try the most common cart drawer triggers used by Archetype themes
    var drawer = document.querySelector('#CartDrawer, .bo-cart-panel, [data-cart-drawer]');
    if (drawer) {
      drawer.classList.add('drawer--is-open', 'is-open', 'is-active');
    }
    // Also try clicking a cart toggle button if one exists
    var cartToggle = document.querySelector('[data-drawer-toggle="cart"], .site-header__cart');
    if (cartToggle && !drawer) {
      cartToggle.click();
    }
  }

  // ---------- Init ----------

  function initAll() {
    document.querySelectorAll('.grid-product--shoppable').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after dynamic content updates (e.g. filter/pagination)
  document.addEventListener('shopify:section:load', initAll);
})();